var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 5 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("TaskSkill", {
                ref: "taskSkill",
                attrs: { taskId: _vm.taskId, flowId: _vm.flowId },
                on: {
                  handleGetParams: _vm.handleGetParams,
                  handleClearParams: _vm.handleClearParams
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("el-col", { attrs: { span: 12 } }, [
            _c(
              "div",
              { staticClass: "grid-content bg-purple" },
              [_c("TaskSkillParams", { ref: "skillParams" })],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }